import { z } from "zod";

export const ReportExecutionHistoryColumnDtoSchema = z.object({
    id: z.string(),
    group: z.string(),
    column: z.string(),
    columnOrder: z.number().nullable(),
    reportExecutionHistoryId: z.string(),
});

export type ReportExecutionHistoryColumnDto = z.infer<typeof ReportExecutionHistoryColumnDtoSchema>;